function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import thunkHelper from 'invision-core/src/api/thunk.helper';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
export var RETRIEVE_CONTRACT_EVENTS = {
  BEGIN: 'RETRIEVE_CONTRACT.BEGIN',
  SUCCESS: 'RETRIEVE_CONTRACT.SUCCESS',
  FAILURE: 'RETRIEVE_CONTRACT.FAILURE'
};
export var retrieveContractPromise = function retrieveContractPromise(dispatch, id) {
  return thunkHelper(dispatch, Object.values(RETRIEVE_CONTRACT_EVENTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderContract',
    data: {
      ContractId: id
    }
  });
};
export var retrieveContract = function retrieveContract(id) {
  return function (dispatch) {
    return retrieveContractPromise(dispatch, id);
  };
};
export var SET_SELECTED_CONTRACT = 'SET_SELECTED_CONTRACT';
export var setSelectedContract = function setSelectedContract(contract) {
  return {
    type: SET_SELECTED_CONTRACT,
    payload: contract
  };
};
export var RETRIEVE_CONTRACT_INSTANCE_EVENTS = {
  BEGIN: 'RETRIEVE_CONTRACT_INSTANCE.BEGIN',
  SUCCESS: 'RETRIEVE_CONTRACT_INSTANCE.SUCCESS',
  FAILURE: 'RETRIEVE_CONTRACT_INSTANCE.FAILURE'
};
export var retrieveContractInstancePromise = function retrieveContractInstancePromise(dispatch, id, customerId) {
  return thunkHelper(dispatch, Object.values(RETRIEVE_CONTRACT_INSTANCE_EVENTS), {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrderContractInstance',
    data: {
      OrderContractInstanceId: id
    },
    headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveContractInstance = function retrieveContractInstance(id, customerId) {
  return function (dispatch) {
    return retrieveContractInstancePromise(dispatch, id, customerId);
  };
};